import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

import { ConfigService } from '../config/config.service';
import { ProductProductCategoriesService } from '../product-categories/product-product-categories.service';
import { ProductCategoriesService } from '../product-categories/product-categories.service';
import { ProductCategory } from '../product-categories/product-category';
import { LoggingService } from '../loging/logging.service';
export class ProductProductCategoriesEditorComponent implements OnInit {
private config: any;
     productId: string;
    productProductCategories: any[];
    productCategories: ProductCategory[];
    productCategoryChecks = {};
/**
 * @param {?} router
 * @param {?} configService
 * @param {?} productProductCategoriesService
 * @param {?} location
 * @param {?} productCategoriesService
 * @param {?} loggingService
 */
constructor(
private router: Router,
private configService: ConfigService,
private productProductCategoriesService: ProductProductCategoriesService,
private location: Location,
private productCategoriesService: ProductCategoriesService,
private loggingService: LoggingService
    ) {
        this.configService.getConfig((configuration: any) => {
            this.config = configuration;
        });
    }
/**
 * @return {?}
 */
ngOnInit(): void {
        this.loggingService.log('ProductProductcategoriesComponent:ngOnInit()');

        if(!this.productId){
            throw "Invalid product";
        }
        this.getProductCategories();
    }
/**
 * @return {?}
 */
getProductCategories(): void {
        this.productCategoriesService.getProductCategories().subscribe(
            productCategories => {
                this.productCategories = productCategories;

                productCategories.forEach(
                    (productCategory) =>{
                        this.productCategoryChecks[productCategory.Key] = false;
                    }
                );

                this.loggingService.log('getProductCategories: productCategoryChecks = ' + JSON.stringify(this.productCategoryChecks));

                this.getProductProductCategories();

            });
    }
/**
 * @return {?}
 */
getProductProductCategories(): void {
        this.productProductCategoriesService.getProductProductCategories(this.productId).subscribe(
            productProductCategories => {
                this.productProductCategories = productProductCategories;
                this.loggingService.log('productProductCategories = ' + JSON.stringify(productProductCategories));

                productProductCategories.forEach(
                    (productProductCategory)=>{
                        this.loggingService.log('productProductCategory = ' + JSON.stringify(productProductCategory));

                        this.productCategoryChecks[productProductCategory.ProductCategory.Key] = true;
                    }
                )

                this.loggingService.log('getProductProductCategories: productCategoryChecks = ' + JSON.stringify(this.productCategoryChecks));

            });
    }
/**
 * @param {?} productId
 * @param {?} productCategory
 * @return {?}
 */
addProductProductCategory(productId: string, productCategory: string): void {

        this.loggingService.log('addProductProductCategory productCategory = ' + productCategory);

        this.productProductCategoriesService.addProductProductCategory(productId, productCategory).subscribe(
            (next: any) => {
                this.getProductCategories();
            }
        )
    }
/**
 * @param {?} productId
 * @param {?} productCategory
 * @return {?}
 */
deleteProductProductCategory(productId: string, productCategory: string): void {
        this.productProductCategoriesService.deleteProductProductCategory(productId, productCategory).subscribe(
            () => {

                this.productProductCategories = this.productProductCategories.filter(p => p.ProductCategory.Key !== productCategory);

                this.productCategoryChecks[productCategory] = false;
            });
    }
/**
 * @return {?}
 */
goBack(): void {
        this.location.back();
    }
/**
 * @param {?} productCategory
 * @return {?}
 */
productHasCategory(productCategory: string): boolean {
        return true;
    }
/**
 * @param {?} productCategory
 * @return {?}
 */
toggleProductHasCategory(productCategory: string) {
        // this.productCategoryChecks[productCategory] = !this.productCategoryChecks[productCategory];

        // this.loggingService.log('this.productCategoryChecks[' + productCategory + '] = ' + this.productCategoryChecks[productCategory]);

        if(this.productCategoryChecks[productCategory]){

            this.loggingService.log('delete product category: productId = ' + this.productId + ' productCategory = ' + productCategory);

            this.deleteProductProductCategory(this.productId, productCategory);
            
        } else {

            this.loggingService.log('add product category: productId = ' + this.productId + ' productCategory = ' + productCategory);

            this.addProductProductCategory(this.productId, productCategory);

        }
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'my-product-product-categories-editor',
    template: "<div> <div *ngFor=\"let productCategory of productCategories\" class=\"row\"> <div class=\"col-xs-12 product-category-div\"> <span class=\"product-category-name\">{{productCategory.Key}}&nbsp;&nbsp;</span> <input id=\"{{productCategory.Key}}-checkbox\" type=\"checkbox\" [checked]=\"productCategoryChecks[productCategory.Key]\" (change)=\"toggleProductHasCategory(productCategory.Key)\">  </div> </div> <button (click)=\"goBack()\">Back</button> </div>",
    styles: [""]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Router, },
{type: ConfigService, },
{type: ProductProductCategoriesService, },
{type: Location, },
{type: ProductCategoriesService, },
{type: LoggingService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'productId': [{ type: Input },],
};
}

function ProductProductCategoriesEditorComponent_tsickle_Closure_declarations() {
/** @type {?} */
ProductProductCategoriesEditorComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProductProductCategoriesEditorComponent.ctorParameters;
/** @type {?} */
ProductProductCategoriesEditorComponent.propDecorators;
/** @type {?} */
ProductProductCategoriesEditorComponent.prototype.config;
/** @type {?} */
ProductProductCategoriesEditorComponent.prototype.productId;
/** @type {?} */
ProductProductCategoriesEditorComponent.prototype.productProductCategories;
/** @type {?} */
ProductProductCategoriesEditorComponent.prototype.productCategories;
/** @type {?} */
ProductProductCategoriesEditorComponent.prototype.productCategoryChecks;
/** @type {?} */
ProductProductCategoriesEditorComponent.prototype.router;
/** @type {?} */
ProductProductCategoriesEditorComponent.prototype.configService;
/** @type {?} */
ProductProductCategoriesEditorComponent.prototype.productProductCategoriesService;
/** @type {?} */
ProductProductCategoriesEditorComponent.prototype.location;
/** @type {?} */
ProductProductCategoriesEditorComponent.prototype.productCategoriesService;
/** @type {?} */
ProductProductCategoriesEditorComponent.prototype.loggingService;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
